/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const lnbasesettingRouter = {
	path: '/basesetting',
	component: Layout,
	redirect: 'noRedirect',
	name: '设置',
	id: 200000,
	meta: {
		title: '设置',
		icon: 'chart',
		roles: [200000]
	},
	children: [
		{
			path: '',
			component: LayoutView,
			name: '食堂档口',
			id: 201000,
			meta: {
				title: '食堂档口',
				noCache: true,
				roles: [201000]
			},
			children: [
				{
					path: 'area',
					component: () => import('@/leniuview/basesetting/canteenManage/area'),
					name: '区域管理',
					id: 201010,
					meta: { title: '区域管理', roles: [201010], noCache: true }
				},
				{
					path: 'canteen',
					component: () =>
						import('@/leniuview/basesetting/canteenManage/canteen'),
					name: '食堂管理',
					id: 201020,
					meta: { title: '食堂管理', roles: [201020], noCache: true }
				},
				{
					path: 'canteenManage',
					component: () =>
						import(
							/* webpackChunkName: "canteenManage" */ '@/leniuview/basesetting/canteenManage'
						),
					redirect: 'canteenManage/shopstall',
					name: '档口/餐线',
					id: 201030,
					meta: {
						title: '档口/餐线',
						noCache: true,
						roles: [201030]
					},
					children: [
						{
							path: 'shopstall',
							component: () =>
								import('@/leniuview/basesetting/canteenManage/shopstall'),
							name: '档口管理',
							meta: { title: '档口管理', roles: [201030], noCache: true },
							hidden: true
						},
						{
							path: 'mealline',
							component: () =>
								import('@/leniuview/basesetting/canteenManage/mealline'),
							name: '餐线管理',
							meta: { title: '餐线管理', roles: [201030], noCache: true },
							hidden: true
						}
					]
				},
				{
					path: 'canteenManage2',
					component: () =>
						import(
							/* webpackChunkName: "canteenManage" */ '@/leniuview/basesetting/canteenManage/index2'
						),
					redirect: 'canteenManage2/privateRoom',
					name: '包间/餐桌',
					id: 201040,
					meta: {
						title: '包间/餐桌',
						noCache: true,
						roles: [201040]
					},
					children: [
						{
							path: 'desk',
							component: () =>
								import('@/leniuview/basesetting/canteenManage/desk'),
							name: '餐桌管理',
							meta: { title: '餐桌管理', roles: [201040], noCache: true },
							hidden: true
						},
						{
							path: 'privateRoom',
							component: () =>
								import('@/leniuview/basesetting/canteenManage/private-room'),
							name: '包间管理',
							meta: { title: '包间管理', roles: [201040], noCache: true },
							hidden: true
						}
					]
				},
				{
					path: 'canteenManage3',
					component: () =>
						import(
							/* webpackChunkName: "canteenManage" */ '@/leniuview/basesetting/canteenManage/index3'
						),
					redirect: 'canteenManage3/address',
					name: '其他管理',
					id: 201050,
					meta: {
						title: '其他管理',
						noCache: true,
						roles: [201050]
					},
					children: [
						{
							path: 'tag',
							component: () => import('@/leniuview/basesetting/canteenManage/tag'),
							name: '标签',
							meta: { title: '标签', roles: [201050], noCache: true },
							hidden: true
						},
						{
							path: 'type',
							component: () => import('@/leniuview/basesetting/canteenManage/type'),
							name: '档口品类',
							meta: { title: '档口品类', roles: [201050], noCache: true },
							hidden: true
						},
						{
							path: 'address',
							component: () =>
								import('@/leniuview/basesetting/canteenManage/address'),
							name: '取餐点',
							meta: { title: '取餐点', roles: [201050], noCache: true },
							hidden: true
						}
					]
				}
			]
		},
		{
			path: 'userrole',
			component: LayoutView,
			name: '权限管理',
			id: 204000,
			meta: {
				title: 'lnbasesetting.machinerole',
				noCache: true,
				roles: [204000]
			},
			redirect: 'roles',
			children: [
				{
					path: 'role',
					component: () =>
						import(
							/* webpackChunkName: "role" */ '@/leniuview/basesetting/role/mgrrole'
						),
					name: '角色',
					id: 204900,
					meta: { title: '角色', noCache: true, roles: [204900] }
				},
				{
					path: 'userrole',
					component: () =>
						import(
							/* webpackChunkName: "userrole" */ '@/leniuview/basesetting/role/mgruser'
						),
					name: '用户',
					id: 204200,
					meta: {
						title: '用户',
						noCache: true,
						roles: [204200]
					}
				},
				{
					path: 'effective',
					component: () =>
						import(
							/* webpackChunkName: "effective" */ '@/leniuview/basesetting/role/effective'
						),
					name: '数据权限',
					id: 204300,
					meta: {
						title: 'lnbasesetting.effective',
						noCache: true,
						roles: [204300]
					}
				}
			]
		},
		{
			path: 'otherset',
			component: () =>
				import('@/leniuview/basesetting/otherSet'),
			name: '其他设置',
			id: 203000,
			meta: {
				title: '其他设置',
				noCache: true,
				roles: [203000]
			},
			children: [
				{
					path: 'helpself',
					component: () => import('@/leniuview/basesetting/otherSet/components/helpself'),
					name: '自助餐设置',
					id: 203010,
					meta: { title: '自助餐设置', roles: [203010], noCache: true }
				},
				{
					path: 'dataScreen',
					component: () =>
						import(
							/* webpackChunkName: "dataScreen" */ '@/leniuview/basesetting/dataScreen/index'
						),
					name: '数据大屏',
					id: 203020,
					meta: {
						title: '数据大屏',
						noCache: true,
						roles: [203020]
					}
				},
				{
					path: 'dataScreendetail',
					component: () =>
						import(
							/* webpackChunkName: "dataScreendetail" */ '@/leniuview/basesetting/dataScreen/detail'
						),
					name: '数据大屏详情',
					meta: {
						title: '数据大屏详情',
						noCache: true,
						roles: [203020]
					},
					hidden: true
				},
				{
					path: 'holiday',
					component: () =>
						import(
							/* webpackChunkName: "holiday" */ '@/leniuview/basesetting/holiday/index'
						),
					name: '法定节假日',
					id: 203030,
					meta: {
						title: '法定节假日',
						noCache: true,
						roles: [203030]
					}
					// dev: true
				},
				{
					path: 'facealgorithm',
					component: () =>
						import('@/leniuview/basesetting/facealgorithm'),
					name: '人脸算法',
					id: 203040,
					meta: { title: '人脸算法', roles: [203040], noCache: true }
				},
				{
					path: 'paytype',
					component: () =>
						import('@/leniuview/basesetting/otherSet/components/paySet'),
					name: '支付方式',
					id: 203050,
					meta: { title: '支付方式', roles: [203050], noCache: true }
				},
				{
					path: 'delivery',
					component: () =>
						import('@/leniuview/basesetting/otherSet/components/peisongSet'),
					name: '配送方式',
					id: 203060,
					meta: { title: '配送方式', roles: [203060], noCache: true }
				}
			]
		}
	]
}

export default lnbasesettingRouter
